import { create } from 'zustand';
import i18n from 'i18n';
import { AuthUtils } from '@shared/utils';
import { AuthApi, type RecoveryConfirmationRequest, RestApiError, StatusCodeEnum } from '@shared/api';
import type { BaseReturn } from '@shared/types';

interface UseRecoveryConfirmationStore {
  loading: boolean;
  data: boolean | null;
  error?: string | null;
  recoveryConfirmation: (request: RecoveryConfirmationRequest) => Promise<BaseReturn<any | null>>;
  clear: () => void;
}

export const useRecoveryConfirmationStore = create<UseRecoveryConfirmationStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  recoveryConfirmation: async (request) => {
    try {
      set({ loading: true, data: null, error: null });
      await AuthApi.recoveryConfirmation(request);
      AuthUtils.removeRecoveryTempToken();
      set({ loading: false, data: true });
      return { loading: false, data: true };
    } catch (e) {
      const restError = e as RestApiError;

      let errorMessage = 'Something went wrong, try again';
      switch (restError?.status) {
        case StatusCodeEnum.API_ERROR_BAD_REQUEST:
          errorMessage = 'Invalid confirmation code';
          break;
        case StatusCodeEnum.API_ERROR_UNAUTHORIZED:
          errorMessage = 'Invalid confirmation code';
          break;
      }

      const error = i18n.t(`errors.api.${errorMessage}`, errorMessage);
      set({ loading: false, data: false, error });
      return { loading: false, data: false, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
